export default __webpack_public_path__ + "static/media/squemaCFDIS.b24d97a5.svg";